<script lang="ts">
    import {isAuth, myProfile} from "../services/auth.service";
</script>

<svelte:head>
    <title>Your profile</title>
</svelte:head>

<h1>Your profile</h1>

<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
<p>Authenticated: {$isAuth}</p>

{#if $myProfile}
    <p>All about me:</p>
    {#if $myProfile.picture}
        <img src="{$myProfile.picture}" alt="My avatar">
    {/if}
    <p>
        Nickname: {$myProfile.nickname}<br>
        Name: {$myProfile.name}<br>
        Email: {$myProfile.email}<br>
        <span style="color: {$myProfile.email_verified ? 'green' : 'orange'}">
            Email {$myProfile.email_verified ? 'verified' : 'not verified'}
        </span>
    </p>
{/if}
